"use strict";
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStorage = void 0;
var useKey_1 = require("./useKey");
var useNoKey_1 = require("./useNoKey");
var useStorage = function (key, callback, options) {
    if (options === void 0) { options = {}; }
    return (key ? useKey_1.useKey : useNoKey_1.useNoKey).apply(_this, key ? [key, callback, options] : [callback, options]);
};
exports.useStorage = useStorage;
//# sourceMappingURL=index.js.map